/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSportsIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-sports"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M11.07 19.15Q8.5 19.15 6.69 17.34Q4.88 15.53 4.88 12.95Q4.88 12.68 4.9 12.4Q4.92 12.13 4.97 11.85Q4.83 11.9 4.65 11.93Q4.47 11.95 4.33 11.95Q3.23 11.95 2.48 11.2Q1.73 10.45 1.73 9.35Q1.73 8.25 2.44 7.5Q3.15 6.75 4.25 6.75Q5.13 6.75 5.81 7.22Q6.5 7.7 6.78 8.45Q7.65 7.65 8.74 7.2Q9.82 6.75 11.07 6.75L20.95 6.75Q21.5 6.75 21.89 7.14Q22.27 7.53 22.27 8.07L22.27 9.53Q22.27 10.07 21.89 10.46Q21.5 10.85 20.95 10.85L17.27 10.85L17.27 12.95Q17.27 15.53 15.46 17.34Q13.65 19.15 11.07 19.15ZM4.35 10.35Q4.35 10.35 4.56 10.35Q4.78 10.35 5.08 10.05Q5.38 9.75 5.38 9.32Q5.38 8.9 5.08 8.6Q4.78 8.3 4.35 8.3Q3.92 8.3 3.63 8.6Q3.33 8.9 3.33 9.32Q3.33 9.75 3.63 10.05Q3.92 10.35 4.35 10.35ZM11.07 15Q11.07 15 11.5 15Q11.93 15 12.53 14.4Q13.13 13.8 13.13 12.95Q13.13 12.1 12.53 11.5Q11.93 10.9 11.07 10.9Q10.22 10.9 9.63 11.5Q9.03 12.1 9.03 12.95Q9.03 13.8 9.63 14.4Q10.22 15 11.07 15Z" fill={color} />
    </svg>
  );
}
